import { useCallback } from "react"
import { enqueueSnackbar } from "notistack"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()(() => ({
    deadlineSnackbar: {
        maxWidth: "30rem",
        flexWrap: "nowrap",
    },
}))

// merchant-authored text needs a wider snackbar
export function useDeadlineSnackbar() {
    const { classes } = useStyles()

    return useCallback(
        (text: string, variant: "info" | "warning") => {
            enqueueSnackbar(text, { variant, className: classes.deadlineSnackbar })
        },
        [classes.deadlineSnackbar],
    )
}
